import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';
import SettingsSuggestRoundedIcon from '@mui/icons-material/SettingsSuggestRounded';
import ThumbUpAltRoundedIcon from '@mui/icons-material/ThumbUpAltRounded';
import SubscribeForm from './SubscribeForm';
import { Button } from '@mui/material';
import { useAuth } from '../contexts/authContext';
import TrialNotice from './TrialNotice';


const items = [
  {
    icon: <SettingsSuggestRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Integrate Argos into your workflows (for Individual use)',
    description:
      '',
  },
  {
    icon: <ConstructionRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Official documentation for Argos API v.1.0.0',
    description:
      'Available at',
    link: 'https://scitility.github.io/argos-api-doc-public/',
    linkName: 'Official documentation'
  },
  {
    icon: <ThumbUpAltRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Github repo',
    description:
      'Our OpenApi specification is available at',
    link: 'https://github.com/scitility/argos-api-doc-public',
    linkName: 'Github repo'
  }
];

export default function ApiContent() {

  const { institutionalRoles } = useAuth()

  return (
    <Stack
      direction="column"
      component="main"
      sx={[
        {
          justifyContent: 'space-between',
          height: { xs: 'auto', md: '100%' },
        },
        (theme) => ({
          marginTop: -8,
          backgroundImage:
            'radial-gradient(ellipse at 70% 51%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
          backgroundSize: 'cover',
          ...theme.applyStyles('dark', {
            backgroundImage:
              'radial-gradient(at 70% 51%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))',
          }),
        }),
      ]}
    >
      <Stack
        direction={{ xs: 'column-reverse', md: 'row' }}
        sx={{
          justifyContent: 'center',
          gap: { xs: 6, sm: 12 },
          p: { xs: 2, sm: 4 },
          m: 'auto',
          mt: 0
        }}
      >
        <Stack
          sx={{ flexDirection: 'column', alignSelf: 'center', gap: 4, maxWidth: 450 }}
        >
          {items.map((item, index) => (
            <Stack key={index} direction="row" sx={{ gap: 2 }}>
              {item.icon}
              <div>
                <Typography gutterBottom sx={{ fontWeight: 'medium' }}>
                  {item.title}
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  {item.description}
                </Typography>
                {item.link &&
                  <form action={item.link} method="GET" target='_blank'>
                    <Button type='submit' variant='contained' sx={{ width: { md: 'auto', sm: '100%' }, pl: { md: 5 }, pr: 5, ml: { md: 5, sm: 0 }, mr: { md: 5, sm: 2 }, mt: 2, mb: 2, backgroundColor: "#003366", border: '5px solid #ADFF5C' }}>{item.linkName}</Button>
                  </form>
                }
              </div>
            </Stack>
          ))}
        </Stack>
        {institutionalRoles.length > 0 && institutionalRoles[0][0] === 'https://openalex.org/I161913731' &&
          <TrialNotice />
        }
        {(institutionalRoles.length === 0 || institutionalRoles[0][0] !== 'https://openalex.org/I161913731') &&
          <SubscribeForm productPricePerMonth='20' productId='prod_RGWs3ra7kxAYsz' productName='Argos Pro+' addFreeNotice={false} annualProductId={undefined} productPricePerAnnum={undefined} />
        }
      </Stack>
    </Stack>
  );
}